import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import GoogleMapsLink from '../../../components/GoogleMapsLink';

const MapComponent = ({ latitude, longitude, address, type, showAddress = true, showGoogleMapsLink = true, height = '200px' }) => {
    console.log('MapComponent latitude', latitude);
    console.log('MapComponent longitude', longitude);
    console.log('MapComponent address', address);

    // Ensure address is a string, not an object
    const safeAddress = typeof address === 'string' ? address : 
                       (address?.full_address || address?.address || 'Location not available');

    const mapContainerRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const markerRef = useRef(null);

    useEffect(() => {
        // Ensure Leaflet default marker icons render correctly in bundlers
        // by overriding the icon URLs with CDN paths.
        // This runs once.
        delete L.Icon.Default.prototype._getIconUrl;
        L.Icon.Default.mergeOptions({
            iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
            iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
            shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png'
        });
    }, []);

    useEffect(() => {
        if (!mapContainerRef.current) return;

        const lat = parseFloat(latitude);
        const lng = parseFloat(longitude);
        const locationArray = [isNaN(lat) ? 0 : lat, isNaN(lng) ? 0 : lng];

        if (!mapInstanceRef.current) {
            mapInstanceRef.current = L.map(mapContainerRef.current, {
                center: locationArray,
                zoom: 15,
                zoomControl: true
            });

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap contributors',
                maxZoom: 19
            }).addTo(mapInstanceRef.current);

            markerRef.current = L.marker(locationArray, { title: type === "doctor" ? "Doctor's Location" : "Hospital's Location" }).addTo(mapInstanceRef.current);
        } else {
            mapInstanceRef.current.setView(locationArray, 15);
            if (markerRef.current) {
                markerRef.current.setLatLng(locationArray);
            } else {
                markerRef.current = L.marker(locationArray, { title: type === "doctor" ? "Doctor's Location" : "Hospital's Location" }).addTo(mapInstanceRef.current);
            }
        }

        return () => {
            if (mapInstanceRef.current) {
                mapInstanceRef.current.remove();
                mapInstanceRef.current = null;
                markerRef.current = null;
            }
        };
    }, [latitude, longitude]);

    return (
        <div style={{ width: '100%' }}>
            {/* Address Display */}
            {showAddress && safeAddress && (
                <div style={{
                    marginBottom: '10px',
                    padding: '10px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: showGoogleMapsLink ? '8px' : '0'
                    }}>
                        <i className="ti-location-pin" style={{ color: '#dc3545', fontSize: '16px' }}></i>
                        <span style={{ 
                            fontSize: '14px', 
                            color: '#495057',
                            fontWeight: '500'
                        }}>
                            {type === "doctor" ? "Doctor's Location" : "Hospital's Location"}
                        </span>
                    </div>
                    
                    <div style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        lineHeight: '1.4',
                        marginBottom: showGoogleMapsLink ? '8px' : '0'
                    }}>
                        {safeAddress}
                    </div>
                    
                    {/* Google Maps Link */}
                    {showGoogleMapsLink && (
                        <GoogleMapsLink 
                            latitude={parseFloat(latitude)}
                            longitude={parseFloat(longitude)}
                            address={safeAddress}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                fontSize: '13px',
                                color: '#0066cc',
                                textDecoration: 'none',
                                backgroundColor: '#e7f3ff',
                                padding: '6px 12px',
                                borderRadius: '4px',
                                border: '1px solid #b3d9ff'
                            }}
                        >
                            <i className="fas fa-map-marked-alt"></i>
                            Open in Google Maps
                            <i className="fas fa-external-link-alt" style={{ fontSize: '10px' }}></i>
                        </GoogleMapsLink>
                    )}
                </div>
            )}
            
            {/* Map Container */}
            <div
                ref={mapContainerRef}
                style={{
                    width: '100%',
                    height: height,
                    borderRadius: '8px',
                    overflow: 'hidden',
                    border: '1px solid #dee2e6',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
            />
            
            {/* Map Attribution */}
            <div style={{
                fontSize: '10px',
                color: '#6c757d',
                textAlign: 'center',
                marginTop: '4px'
            }}>
                Powered by OpenStreetMap
            </div>
        </div>
    );
};

export default MapComponent;
